import muster from '@dbk-legacy/muster';
import { watchValues } from '@dbk-legacy/muster/utils';
import has from 'lodash/has';
import replace from 'lodash/replace';
import settings from '../data/settings.json';
import { getValues, ref } from '@dbk-legacy/muster/utils';
import { variable, redirectOn } from '@dbk-legacy/muster/helpers';
import { CHANNEL_TYPES } from '../constants';

const isInternalElement = document.getElementById('isInternal');
const isWebssoInternal = isInternalElement != null ? isInternalElement.value : null;


let storedCurrentEnvironment;

export default () =>
  muster()



    .path('app.config.apiverion', variable("1.0"))
    .path('app.config.regioncode', variable(""))
    .path('app.config.showchangepassword', variable(false))
    .path('app.config.branchCode', variable(""))
    .path('app.config.chat.enabled', variable(false))
    // Feature/EBANK-17839 create app without rendering
    // .path('app.config.trading.tradeComponentDisabled',variable(true))
    .path('app.config.chat.enableAttachment', variable(false))
    .path('app.config.chat.url', variable())
    .path( 'settings.websocketStaticUrl.socketUrl',
    ({ res }) => res.value(settings.websocketStaticUrl.socketUrl))
    .path('app.config.uploadFileMaxSize', variable('10485760'))
    .path('app.config.upload5MB', variable())
    .path('app.config.parallelCallCount', variable())
    .path('app.config.chunkSize', variable())
    .path('app.config.activetimeout', variable('50000'))
     .path('app.config.logoutdebug',variable(false))
    .path('app.config.assetPageSize', variable())
    .path('app.getConfig', {
      call: async ({ req }, { get, set, call }) => {
        const ran_str = "random" + Math.round(Math.random() * 1000);
        const [appConfig] = await getValues(get([`roster.ebanking.app.config.["${ran_str}"]`]));
        const config = JSON.parse(appConfig);
        console.log("API CONFIG FROM FALCOR ==> ", config);
        await set('app.config.branchCode', config.branchCode);
        const portfolio = { branchCode: config.branchCode };
        await set('app.user.selectedPortfolioData', portfolio);
        const [environmentUrl, defaultEnvironment] = await getValues(
          get([
            'settings.currentEnvironment.remoteUrl',
            'settings.defaultEnvironment'
          ])
        );
        const [authHeader] = await getValues(get(['auth.authHeader']));
        const [userId] = await getValues(get(['auth.userId']));
        let chatUrl;

        if (defaultEnvironment === "local" || defaultEnvironment === "static") {
          [chatUrl] = await getValues(get('settings.websocketStaticUrl.socketUrl'));
        } else if(isWebssoInternal){
            chatUrl = window.mapped_ws_url;
        } else{
          chatUrl = `wss://${window.location.hostname}/wsreq`;
        }
        await Promise.all([
          set('app.config.apiverion', config.apiversion),
          set('app.config.regioncode', config.region),
          set('app.config.showchangepassword', config.showforgotpassword),
          call('loginTerms.getPdfLink'),
          set('app.config.chat.url', chatUrl),
          set('app.config.chat.enabled', config.chat.enabled),
          // Feature/EBANK-17839 create app without rendering
          // set('app.config.trading.tradeComponentDisabled', config.trading.tradeComponentDisabled),
          set('app.config.chat.enableAttachment', config.chat.enableAttachment),
          set('auth.channel', CHANNEL_TYPES.WEB),  // temporary fix for Password reset for WEB
          set('app.config.uploadFileMaxSize', config.uploadFileMaxSize),
          set('app.config.upload5MB', config.upload5MB),
          set('app.config.chunkSize', config.chunkSize),
          set('app.config.parallelCallCount', config.parallelCallCount),
          set('app.config.activetimeout', config.activetimeout),
          set('app.config.logoutdebug',config.logoutdebug),
          set('app.config.assetPageSize',config.assetPageSize),
          set('app.config.showOrderReport', config.showOrderReport),
          set('app.config.isAirLockUpgrade', config.isAirLockUpgrade)
        ]);


      },
    })

    .path(
    'settings.defaultEnvironment',
    ({ res }, { get }) =>
      watchValues(get('device.uniqueId'))
        .map(([uniqueId]) => {
          if (has(settings, `devices.${uniqueId}.defaultEnvironment`)) {
            return res.value(settings.devices[uniqueId].defaultEnvironment);
          }

          return res.value(settings.defaultEnvironment);
        })
    )
    .path(
    'settings.defaultAllowedEnvironments',
    ({ res }) => res.value(settings.defaultAllowedEnvironments)
    )
    .path(
    'settings.environments',
    ({ res }) => res.value(settings.environments)
    )
    .path(
    'settings.currentEnvironment.id', {
      get: ({ res }, { get }) =>
        watchValues(get('settings.defaultEnvironment'))
          .map(([defaultEnvironment]) =>
            res.value(storedCurrentEnvironment || defaultEnvironment)
          ),
      set: ({ req, res }) => {
        storedCurrentEnvironment = req.value;
        return res.ok();
      },
    }
    )
    .match(
    'settings.currentEnvironment.*',
    (requests, { get }) =>
      watchValues(get(['settings.currentEnvironment.id', 'settings.environments']))
        .map(([currentEnvironment, environments]) =>
          requests.map(({ req, res }) => {
            const property = req.params['*'];
            if (!has(environments, currentEnvironment)) {
              return res.value();
            }

            return res.value(environments[currentEnvironment][property]);
          }
          )
        )
    )
    .path(
    'settings.allowedEnvironments',
    ({ res }, { get }) =>
      watchValues(get(['settings.defaultAllowedEnvironments', 'device.uniqueId']))
        .map(([defaultAllowedEnvironments, uniqueId]) => {
          if (has(settings, `devices.${uniqueId}.allowedEnvironments`)) {
            return res.value(settings.devices[uniqueId].allowedEnvironments);
          }

          return res.value(defaultAllowedEnvironments);
        })
    )
    .path('app.config.showOrderReport', variable(false))
    .path('app.config.isAirLockUpgrade', variable(false));
